import {Dispatch} from 'redux';
import {
  ADD_TRANSACTION,
  AddTransactionAction,
} from 'types/actions/Transaction.actions';

export const addTransaction = (
  hash: string,
  summary: string,
  from: string,
  options?: {
    addedTime?: number;
    completeMessage?: string;
    errorMessage?: string;
    onComplete?: (isSucceed?: boolean) => void;
  },
) => (dispatch: Dispatch<AddTransactionAction>) =>
  dispatch({
    type: ADD_TRANSACTION,
    hash,
    onComplete: options?.onComplete,
    payload: {
      hash,
      summary,
      from,
      completeMessage: options?.completeMessage,
      errorMessage: options?.errorMessage,
      addedTime: options?.addedTime || Date.now(),
    },
  });
